import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import AbstractImage from "lib/images/AbstractShapeLeft.svg";

import { PageHeader } from "../../components/Admin/AppsSettings/CardStyles";

import AppCard from "./AppCard";
import { getApps, activateApp, deactivateApp } from "./appPage.store";
import { getPermissionedUserByCompanyId } from "pages/lenderReportingDashboard/lenderReportingDashboard.store";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  border-top: 1px solid #DADCE0;
  border-bottom: 1px solid #DADCE0;
`;

const HeaderContainerInnerWrapper = styled.div`
  display: inherit;
  width: 100%;
  max-width: 1920px;
  flex-direction: row;
  align-items: center;
  gap: 3em;
`;

const PageSubHeader = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 21.11px;
  color: #5F6368;
  font-family: Work Sans;
  max-width: 580px;
`;

const AppsSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const AppsSectionWrapper = styled.div`
  width: 100%;
  max-width: 1920px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  padding: 2em 0;
`;

const Apps = (props) => {
  const {authentication, apps = [], history, permissionedUsersByCompany} = props;
  const [filteredApps, setFilteredApps] = useState(apps);

  useEffect(() => {
    props.getApps();
    props.getPermissionedUserByCompanyId();
  }, []);

  useEffect(() => {
    /*
    * Filter out Lender Reporting app if user is not system admin and not included in the permissioned users list at lenderReportingDashboard/settings
    */
    const contactId = authentication?.user?.contact?.id;
    const isSystemAdmin = authentication?.isSystemAdmin;

    let filtered = apps;
    if (authentication && !isSystemAdmin) {
      const isUserIncluded = !!permissionedUsersByCompany.find((user) => user.contactId === contactId);
      if (!isUserIncluded) {
        filtered = apps.filter((app) => app.id !== "83d35f75-f91e-464c-a534-ddfe5c7873a7");
      }
    }
    setFilteredApps(filtered);
  }, [apps, permissionedUsersByCompany, authentication]);

  return (
    <PageContainer>
      <HeaderContainer>
        <HeaderContainerInnerWrapper>
          <img src={AbstractImage} alt="abstract_img" />
          <div>
            <PageHeader>Do more with your deals</PageHeader>
            <PageSubHeader>
              Leverage your deal information and make smarter decisions with LoanBoss Apps. Contact your Account Manager for more information about any App.
            </PageSubHeader>
          </div>
        </HeaderContainerInnerWrapper>
      </HeaderContainer>
      <AppsSectionContainer>
        <AppsSectionWrapper>
          {filteredApps.map(app => <AppCard
            key={`${app.id}`}
            app={app}
            onActivateApp={() => props.activateApp(app.id)}
            onDeactivateApp={() => props.deactivateApp(app.id)}
            isSystemAdmin={authentication.isSystemAdmin}
            history={history}
          />)}
        </AppsSectionWrapper>
      </AppsSectionContainer>
    </PageContainer>
  );
};

const mapStateToProps = ({ authentication, appsPage, lenderReportingDashboard }) => ({
  authentication,
  apps: _.sortBy(appsPage.apps, ["name"]),
  permissionedUsersByCompany: lenderReportingDashboard.permissionedUsersByCompany
});

export default compose(connect(mapStateToProps, { getApps, activateApp, deactivateApp, getPermissionedUserByCompanyId }))(Apps);
